import gql from 'graphql-tag';

export const ChangeHubPublishStateWriteQuery = gql`
	query ChangeHubPublishStateWriteQuery {
		siteSettings {
			frontCover {
				frontCoverState
			}
		}
	}
`;
